import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

export const filterClientPortfoliosSchema = z.object({
  strategy_from_id: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  strategy_to_id: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  weight_greater_than: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  weight_less_than: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  market_value_greater_than: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  market_value_less_than: z
    .preprocess(
      (val) => (val === "" ? undefined : Number(val)),
      z.number().optional(),
    )
    .optional(),
  closing_date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  closing_date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterClientPortfoliosSchema = z.infer<
  typeof filterClientPortfoliosSchema
>;

export const fields: Field[] = [
  {
    name: "strategy_from_id",
    label: "Strategy From",
    type: "input",
    input_type: "number",
  },
  {
    name: "strategy_to_id",
    label: "Strategy To",
    type: "input",
    input_type: "number",
  },
  {
    name: "weight_greater_than",
    label: "Weight Greater Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "weight_less_than",
    label: "Weight Less Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "market_value_greater_than",
    label: "Market Value Greater Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "market_value_less_than",
    label: "Market Value Less Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "closing_date_from",
    label: "Closing Date From",
    type: "date",
  },
  {
    name: "closing_date_to",
    label: "Closing Date To",
    type: "date",
  },
  {
    name: "created_at_from",
    label: "Created At From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created At To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated At From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated At To",
    type: "date",
  },
];

export const client = "instit-quantilia";

export function FilterClientPortfolios() {
  return (
    <FilterTable
      client={client}
      schema={filterClientPortfoliosSchema}
      tableName="client_portfolios"
      customBuildPath={() => `${client}/client_portfolios`}
      fields={fields}
      columns={2}
    />
  );
}
